var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-layout',{attrs:{"layout":['xs12']}},[_c('reservation-form',{attrs:{"type":_vm.type,"authority":_vm.auth,"reservation":_vm.newReservation,"status":_vm.status,"id":_vm.id},on:{"updateReservation":_vm.setReservation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }